import { createContext } from 'react';

export const CardCampSettingContext = createContext<{
  onFormChange?: (hasUncommitted: boolean) => void;
}>({});
